import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as actions from './_actions';
import * as types from './_actionTypes';
import StudentCertificateHelper from '../../../../utils/API/BackendHelper/student/certificate';
import CertificateHelper from '../../../../utils/API/BackendHelper/certificate';
import { downloadCertificate } from '../../../../utils/certificateGenerator';

/**
 * Fetch student results saga
 * For now, results are shown as "to be announced"
 */
function* fetchStudentResultsSaga() {
  try {
    const resultsData = {
      quizzes: [],
      assessments: [],
      exam: null,
      overall: null,
      isAnnounced: false
    };
    
    yield put(actions.fetchStudentResultsSuccess(resultsData));
  } catch (error) {
    yield put(actions.fetchStudentResultsFailure(error.message));
  }
}

/**
 * Fetch certificates saga
 */
function* fetchCertificatesSaga() {
  try {
    const response = yield call([StudentCertificateHelper, 'getMyCertificates']);
    
    if (response.success) {
      const certificates = response.data.map(cert => ({
        id: cert.id,
        certificateNumber: cert.certificate_number,
        issuedDate: cert.issued_date || cert.created_at,
        isApproved: cert.is_approved,
        isRevoked: cert.is_revoked,
        status: cert.is_approved ? 'issued' : 'pending',
        // Course details
        courseId: cert.course_id,
        courseName: cert.courses?.title || 'Course',
        courseCode: cert.courses?.course_code,
        // Keep original data for PDF generation
        originalData: cert
      }));
      
      yield put(actions.fetchCertificatesSuccess(certificates));
    } else {
      yield put(actions.fetchCertificatesFailure(response.message || 'Failed to fetch certificates'));
    }
  } catch (error) {
    yield put(actions.fetchCertificatesFailure(error.message));
  }
}

/**
 * Download certificate saga
 * Uses the new integrated certificate system
 */
function* downloadCertificateSaga(action) {
  const { certificateId } = action.payload;
  
  try {
    // Fetch certificate details using the new CertificateHelper
    const certificateData = yield call(
      [CertificateHelper, 'fetchCertificateForPDF'],
      certificateId,
      false // usePublicEndpoint = false (authenticated)
    );
    
    // Generate and download the PDF
    yield call(downloadCertificate, certificateData);
    
    yield put({
      type: types.DOWNLOAD_CERTIFICATE_SUCCESS,
      payload: { certificateId },
      meta: { certificateId }
    });
  } catch (error) {
    yield put({
      type: types.DOWNLOAD_CERTIFICATE_FAILURE,
      payload: error.message || 'Failed to download certificate',
      meta: { certificateId }
    });
  }
}

function* studentResultsSaga() {
  yield takeLatest(types.FETCH_STUDENT_RESULTS_REQUEST, fetchStudentResultsSaga);
  yield takeLatest(types.FETCH_CERTIFICATES_REQUEST, fetchCertificatesSaga);
  yield takeLatest(types.DOWNLOAD_CERTIFICATE_REQUEST, downloadCertificateSaga);
}

export default studentResultsSaga;